import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { ErrorBoundary } from 'components/ErrorBoundary';
import Header from 'components/Header';
import QuestionField from 'components/Input/QuestionField';
import { htmlId } from 'utils/html';

import EndAdvocateChatModal from './EndAdvocateChatModal';
import { StyledBodyContent, StyledLayout } from './Layout.styles';
import {
  getCachedHideEndChatBtn,
  saveHideEndChatToStorage,
  saveEndChatModalTypeToStorage,
  getCachedEndChatModalType,
} from './utils';
import { END_CHAT } from './EndAdvocateChatModal/content';

const defaults = {
  hideEndChat: true,
  modalType: END_CHAT,
};

const Layout = () => {
  const cachedHideEndChatBtn = getCachedHideEndChatBtn();
  const cachedModalType = getCachedEndChatModalType();

  const [showEndChatModal, setShowEndChatModal] = useState(false);
  const [hideEndChatButton, setHideEndChatButton] = useState(
    cachedHideEndChatBtn ?? defaults.hideEndChat,
  );
  const [modalType, setModalType] = useState(cachedModalType ?? defaults.modalType);

  const toggleEndChatModal = () => setShowEndChatModal(!showEndChatModal);

  const handleHideEndChat = (hidden: boolean) => {
    setHideEndChatButton(hidden);
    saveHideEndChatToStorage(hidden);
  };

  const handleEndChatModalType = (type: string) => {
    setModalType(type);
    saveEndChatModalTypeToStorage(type);
  };

  return (
    <StyledLayout id={htmlId('app')}>
      <ErrorBoundary>
        <Header
          id={htmlId('header')}
          endChatModalType={modalType}
          handleHideEndChat={handleHideEndChat}
          handleEndChatModalType={handleEndChatModalType}
          hideEndChatButton={hideEndChatButton}
          showEndChatModal={showEndChatModal}
          toggleEndChatModal={toggleEndChatModal}
        />
        <StyledBodyContent id={htmlId('body')}>
          <Outlet />
        </StyledBodyContent>
        <QuestionField id={htmlId('input-question-field')} />
        {showEndChatModal && (
          <EndAdvocateChatModal
            toggleEndChatModal={toggleEndChatModal}
            handleHideEndChat={handleHideEndChat}
            modalType={modalType}
          />
        )}
      </ErrorBoundary>
    </StyledLayout>
  );
};

export default Layout;
